import React, { useState, useEffect, useRef } from 'react'
import TWControls from '../controls/TWControls'
import { Form, useForm } from '../controls/useForm'
import { Download as GetAppIcon } from 'lucide-react'
import Popup from 'components/Popup'
import notify from 'components/ui/notify'
import TemplateSiteDetailView from '../TemplateSiteDetailView'
import {
	Table,
	TableHeader,
	TableBody,
	TableHead,
	TableRow,
	TableCell,
} from 'components/ui/table'

const headerCells = [
	{ id: 'templateName', label: 'Template' },
	{ id: 'description', label: 'Description' },
	{ id: 'download', label: 'Download' },
]

const SiteDetailTemplatesSelect = ({ detailTemplates, handleTemplateLoad }) => {
	const validate = () => {
		let temp = { ...errors }

		setErrors({
			...temp,
		})

		return Object.values(temp).every(x => x === '')
	}
	const [openSiteDetailPopup, setOpenSiteDetailPopup] = useState(false)
	const [popupTitle, setPopupTitle] = useState('Template Site Details')
	const [recordForEdit, setRecordForEdit] = useState(null)

	const { values, setValues, errors, setErrors, handleInputChange, resetForm } = useForm(
		// initialValues,
		true,
		validate,
	)

	const openInPopup = task => {
		setRecordForEdit(task)
		setOpenSiteDetailPopup(true)
	}

	const downloadHandler = template => {
		const id = template._id
		notify({
			text: `This will download the ${template.templateName} template to your Site Details list.`,
			buttons: ['Cancel', 'Ok!'],
		}).then(value => {
			if (value) {
				handleTemplateLoad(id, resetForm)
				notify(
					'Downloaded!',
					`The ${template.templateName} template has been downloaded to your Site Details list.`,
					'success',
				)
			}
		})
	}

	return (
		<Form>
			<div className="grid grid-cols-12">
				<div>
					<div>
						<Table>
							<TableHeader>
								<TableRow className="border-b-2 border-[#027fff] hover:bg-transparent">
									{headerCells.map(cell => (
										<TableHead key={cell.id} className="text-gray-700 text-xs font-semibold whitespace-nowrap">
											{cell.label}
										</TableHead>
									))}
								</TableRow>
							</TableHeader>
							<TableBody>
								{detailTemplates.map(template => (
									<TableRow key={template._id} className="h-7 hover:bg-[#fffbf2] cursor-pointer">
										<TableCell
											className="py-1 text-sm"
											onClick={() => {
												setPopupTitle('Template Site Details')
												openInPopup(template)
											}}
										>
											{template.templateName}
										</TableCell>
										<TableCell
											className="py-1 text-sm"
											onClick={() => {
												setPopupTitle('Template Site Details')
												openInPopup(template)
											}}
										>
											{template.description}
										</TableCell>
										<TableCell className="py-1 text-sm">
											<button
												type="button"
												className="inline-flex items-center justify-center rounded-full p-1.5 text-blue-600 hover:bg-blue-50 transition-colors"
												onClick={() => downloadHandler(template)}
											>
												<GetAppIcon className="w-5 h-5" />
											</button>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</div>
				</div>
			</div>
			{/* {openSiteDetailPopup ? (
				<Popup
					title={popupTitle}
					openPopup={openSiteDetailPopup}
					setOpenPopup={setOpenSiteDetailPopup}
				>
					<TemplateSiteDetailView recordForEdit={recordForEdit} />
				</Popup>
			) : null} */}
		</Form>
	)
}

export default SiteDetailTemplatesSelect
